import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";


export class RadioChartCategory extends BaseModel {
    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'RadioChartCategory' })
    MODELNAME: string;

    @JsonProperty({ type: 'number' })
    id: string;

    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'boolean' })
    active: boolean;

    @JsonProperty({ type: 'string?' })
    image_url: string;

}


// WEBPACK FOOTER //
// ./src/api/src/models/radio_chart_category.ts